import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router,Params } from "@angular/router";
import { AuthService } from "app/auth/auth.service";
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";
import * as emiGlobals from 'app/globals';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  userId;
  portalInfo;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private baseInfoService:EmiBaseInfoService
  ) {
    
  }

  ngOnInit() { 
    // this.route.queryParams.subscribe((params: Params) => {
    //   this.userId = params['userId'];
    //  console.log(this.userId);
    //   });
   
    console.log("construted LoadingComponent", this.route.snapshot.data);
    this.portalInfo = this.route.snapshot.data['basic'];
    if(this.portalInfo){
     
      console.log('checking',this.portalInfo);
        this.baseInfoService.updateLocalData(emiGlobals.portalInfo,this.portalInfo.portalInfo);
        this.baseInfoService.updateLocalData(emiGlobals.portalMenu,this.portalInfo.menu);
        this.baseInfoService.updateLocalData(emiGlobals.PortalCity,this.portalInfo.city);
        this.baseInfoService.updateLocalData(emiGlobals.PortalBank_Filter,this.portalInfo.filter_bank_id);
        this.baseInfoService.updateLocalData(emiGlobals.Home_loan_PortalBank_Filter,this.portalInfo.home_filter_bank_id);
        this.baseInfoService.updateLocalData(emiGlobals.Personal_loanPortalBank_Filter,this.portalInfo.personal_filter_bank_id);
        this.baseInfoService.updateLocalData(emiGlobals.PortalBank,this.portalInfo.banks);
        this.baseInfoService.announcePotalDataFetched('fetched');
        try {
          if(this.authService.redirectUrl=='/'){
            if(localStorage.getItem('portalInfo')!=null&&localStorage.getItem('portalInfo')!='/'){
              this.authService.redirectUrl = this.portalInfo.portalInfo.default_url;
            }
          }
  
          console.log('authService redirectUrl',this.authService.redirectUrl);
          this.router.navigateByUrl(this.authService.redirectUrl);
          // this.router.navigate([this.authService.redirectUrl]);
          
        } catch (error) {
          console.log("no route");
          // alert("problem");
        }
     
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.ts